import React, { useState } from 'react';
import { TestSet, Question } from '../../types/models';
import { Button } from '../common/Button';
import { EditTestSet } from './EditTestSet';
import './TestSetList.css';


type TestSetListProps = {
  testSets: TestSet[];
  onTogglePublication: (setId: string, newStatus: boolean) => void;
  onTestSetUpdated?: (updated: TestSet) => void;
  onTestSetDeleted?: (id: string) => void;
  allQuestions?: Question[];
};

export const TestSetList = ({ testSets, onTogglePublication, onTestSetUpdated, onTestSetDeleted, allQuestions = [] }: TestSetListProps) => {
  const handleDelete = async (id: string) => {
    if (!window.confirm('Czy na pewno chcesz usunąć ten zestaw?')) return;
    setIsSaving(true);
    try {
      const { testSetService } = await import('../../services/testSetService');
      await testSetService.deleteTestSet(id);
      if (onTestSetDeleted) onTestSetDeleted(id);
    } catch (e) {
      alert('Błąd podczas usuwania zestawu.');
    } finally {
      setIsSaving(false);
    }
  };
  const [editingId, setEditingId] = useState<string | null>(null);
  const [isSaving, setIsSaving] = useState(false);

  const handleEdit = (id: string) => setEditingId(id);
  const handleCancel = () => setEditingId(null);

  const handleSave = async (id: string, data: { name?: string; questions_ids?: string[] }) => {
    setIsSaving(true);
    try {
      const { testSetService } = await import('../../services/testSetService');
      const updated = await testSetService.updateTestSet(id, data);
      if (onTestSetUpdated) onTestSetUpdated(updated);
      setEditingId(null);
    } catch (e) {
      alert('Błąd podczas edycji zestawu.');
    } finally {
      setIsSaving(false);
    }
  };

  if (testSets.length === 0) {
    return <p>Nie utworzyłeś jeszcze żadnych zestawów testowych.</p>;
  }

  return (
    <div className="test-set-list-container">
      <h3>Istniejące zestawy testowe:</h3>
      <ul>
        {testSets.map((set) => (
          <li key={set.id} className="test-set-item">
            {editingId === set.id ? (
              <EditTestSet
                testSet={set}
                allQuestions={allQuestions}
                onSave={async (data) => handleSave(set.id, data)}
                onCancel={handleCancel}
              />
            ) : (
              <>
                <div className="test-set-info">
                  <strong>{set.name}</strong> ({set.questions.length} pytań)
                  <span className={`status ${set.isPublished ? 'published' : 'draft'}`}>
                    {set.isPublished ? 'Opublikowany' : 'Szkic'}
                  </span>
                </div>
                <Button 
                  onClick={() => onTogglePublication(set.id, !set.isPublished)}
                  variant={set.isPublished ? 'secondary' : 'primary'}
                >
                  {set.isPublished ? 'Cofnij publikację' : 'Opublikuj'}
                </Button>
                <Button style={{ marginLeft: 8 }} onClick={() => handleEdit(set.id)} disabled={isSaving}>Edytuj</Button>
                <Button style={{ marginLeft: 8 }} onClick={() => handleDelete(set.id)} disabled={isSaving}>Usuń</Button>
              </>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};